import { SET_ACCOUNT, SET_ACCOUNT_NAME } from "../actions/accountActionTypes";
import {
  LOGOUT,
  SET_CANCEL_PENDING,
  SET_MERCHANT_USER_ROLE,
} from "../actions/actionTypes";

/**
 * @typedef InitialState
 * @property {string|null} name
 * @property {number|null} id
 * @property {string|null} uuid
 * @property {number|null} subscription
 * @property {string|null} userAccountRole
 * @property {boolean|null} IsManualUpgrade
 * @property {boolean|null} cancelPending
 * @property {boolean|null} isBillingFrozen
 * @property {string|null|undefined} routingKey
 * @property {string|null} trialStartDate
 * @property {string|null} trialEndDate
 * @property {number|null} trialDays
 */

/** @type {InitialState} */
const initialState = {
  id: null,
  uuid: null,
  name: null,
  subscription: null,
  userAccountRole: null,
  IsManualUpgrade: null,
  cancelPending: null,
  isBillingFrozen: null,
  routingKey: null,
  trialStartDate: null,
  trialEndDate: null,
  trialDays: null,
};

/**
 * @param {import("../types").Account} account
 * @returns {string|null}
 */
const readTrialStartDate = (account) =>
  account.trialStartDate ?? account.TrialStartDate ?? null;

/**
 * @param {import("../types").Account} account
 * @returns {string|null}
 */
const readTrialEndDate = (account) =>
  account.trialEndDate ?? account.TrialEndDate ?? null;

/**
 * @param {import("../types").Account} account
 * @returns {number|null}
 */
const readTrialDays = (account) => {
  const days =
    account.trialDays ??
    account.trialDaysRemaining ??
    account.TrialDays ??
    account.TrialDaysRemaining ??
    null;

  if (days == null || days === "") {
    return null;
  }

  const parsed = Number(days);
  return Number.isFinite(parsed) ? parsed : null;
};

/**
 *
 * @param {InitialState} state
 * @param {any} action
 * @returns {InitialState}
 */
const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACCOUNT: {
      /** @type {import("../types").AccountAndUserRole} */
      const accountAndUserRole = action.payload;
      const roleFromPayload = accountAndUserRole.userRole?.name;
      return {
        ...state,
        id: accountAndUserRole.account.id,
        name: accountAndUserRole.account.name,
        uuid: accountAndUserRole.account.uuid,
        subscription: accountAndUserRole.account.currentSubscription,
        userAccountRole:
          roleFromPayload != null ? roleFromPayload : state.userAccountRole,
        IsManualUpgrade: accountAndUserRole.account.IsManualUpgrade || null,
        cancelPending: accountAndUserRole.account.cancelPending || null,
        isBillingFrozen: Boolean(accountAndUserRole.account.isBillingFrozen),
        routingKey:
          "routingKey" in accountAndUserRole.account
            ? accountAndUserRole.account.routingKey
            : accountAndUserRole.account.uuid !== state.uuid
              ? null
              : state.routingKey,
        trialStartDate: readTrialStartDate(accountAndUserRole.account),
        trialEndDate: readTrialEndDate(accountAndUserRole.account),
        trialDays: readTrialDays(accountAndUserRole.account),
      };
    }
    case SET_MERCHANT_USER_ROLE: {
      return {
        ...state,
        userAccountRole: action.payload ?? null,
      };
    }
    case SET_ACCOUNT_NAME: {
      return {
        ...state,
        name: action.payload,
      };
    }
    case SET_CANCEL_PENDING: {
      return {
        ...state,
        cancelPending: action.payload,
      };
    }
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default accountReducer;
